<div class="login-card">
  <div class="login-illustration">
    <img [src]="illustrationUrl" alt="Pixie pet" />
  </div>

  <h2 class="login-title">{{ 'auth.login.welcome' | translate }}</h2>

  <form (ngSubmit)="onSubmit()" [formGroup]="loginForm" class="login-form">
    @if (incorrectCredentials) {
      <p-message class="login-error" severity="error">{{ 'auth.failed' | translate }}</p-message>
    }

    <div class="field-group">
      <input
        [invalid]="formValidation.isInvalid('email')"
        autocomplete="email"
        autofocus
        formControlName="email"
        id="email"
        pInputText
        [placeholder]="'auth.login.email_placeholder' | translate"
        type="email"
      />
      <app-form-error-display [control]="loginForm.get('email')"></app-form-error-display>
    </div>

    @if (!isForgotPasswordMode) {
      <div class="field-group">
        <input
          [invalid]="formValidation.isInvalid('password')"
          autocomplete="current-password"
          formControlName="password"
          id="password"
          pInputText
          [placeholder]="'auth.login.password_placeholder' | translate"
          type="password"
        />
        <app-form-error-display [control]="loginForm.get('password')"></app-form-error-display>
      </div>

      <button
        class="forgot-password"
        type="button"
        [disabled]="loading()"
        (click)="enterForgotPasswordMode()"
      >
        {{ 'auth.login.forgot_password' | translate }}
      </button>

      <app-button
        [label]="'auth.login.submit' | translate"
        [isLoading]="loading()"
        [fullWidth]="true"
        [shadow]="false"
        type="submit"
      ></app-button>
    } @else {
      @if (forgotPasswordMessage) {
        <p-message
          [class]="'login-message login-message--' + forgotPasswordMessage.type"
          [severity]="forgotPasswordMessage.type">
          {{ forgotPasswordMessage.text }}
        </p-message>
      }

      <div class="forgot-password-hint">
        {{ 'auth.login.forgot_password_hint' | translate }}
      </div>

      <app-button
        [label]="'auth.login.reset_password' | translate"
        [isLoading]="loading()"
        [fullWidth]="true"
        [shadow]="false"
        type="button"
        (click)="onForgotPassword()"
      ></app-button>

      <app-button
        [label]="'auth.login.back_to_login' | translate"
        [disabled]="loading()"
        [fullWidth]="true"
        [shadow]="false"
        color="secondary"
        type="button"
        (click)="exitForgotPasswordMode()"
      ></app-button>
    }

    <div class="sso-container">
      <app-sso-buttons (success)="success.emit()" />
    </div>

    <div class="register-cta">
      <span>{{ 'auth.login.no_account' | translate }}</span>
      <button class="link" type="button" (click)="switchToRegister.emit()">{{ 'auth.login.create_account' | translate }}</button>
    </div>
  </form>
</div>
